<template>
    <div
        :class="wrapperClass"
        ref="mobileInputContainer"
    >
        <label
            v-show="placeholder !== '' && !placeholderHidden"
            class="telinput-label"
            ref="mobileInputLabel"
            for="mobile"
        >{{ placeholder }}</label>
        <input
            v-validate="'mobileIsValid'"
            @change="onInput"
            @countrychange="labelPositioning"
            @focus="hidePlaceholder"
            @blur="showPlaceholder"
            :data-vv-as="'phone' | translate"
            ref="mobileInput"
            id="mobile"
            type="text"
            class="form-control"
            name="mobile"
            :disabled="isDisabled"
            autocomplete="off"
            required
            :maxlength="maxlength"
        >
        <InlineError
            :errors="errors"
            type="mobile"
        />
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import InlineError from '@C/Forms/InlineError';
import { initWindowHandler, initEvents, labelPositioning } from '@H/phoneinput';
import { isMobile } from '@H/device_helpers';
import { addSearch } from '@H/search';
import IntlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js';
import countries from '@H/phone/codes';

export default {
    inject: ['$validator'],
    name: 'PhoneInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        wrapperClass: {
            type: String,
            default: 'col-md-8 col-lg-7'
        },
        disabledCheck: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            placeholder: '',
            placeholderHidden: false,
            mobile: this.value,
            mobileCheck: ''
        };
    },
    mounted() {
        let { mobileInput } = this.$refs;

        this.iti = IntlTelInput(mobileInput, {
            separateDialCode: true,
            initialCountry: 'GB',
            customPlaceholder: selectedCountryPlaceholder => {
                this.placeholder = selectedCountryPlaceholder;
                return '';
            }
        });

        this.placeholderHidden = this.mobile !== '';
        let message = this.$gettext(
            'The %{ field } field is invalid. Follow the recommended formatting'
        );

        this.$validator.extend('mobileIsValid', {
            getMessage: field =>
                `${this.$gettextInterpolate(message, { field: field })} (${
                this.placeholder
                }).`,
            validate: () => this.iti.isValidNumber()
        });

        this.iti.promise.then(() => {
            this.preFill();
            let { mobileInputLabel, mobileInputContainer } = this.$refs;
            labelPositioning(mobileInputLabel, mobileInputContainer);

            if (isMobile()) {
                mobileInput.addEventListener('open:countrydropdown', () => {
                    this.postInit(
                        mobileInputContainer,
                        document.body.querySelector('.iti-container')
                    );
                });
            } else {
                this.postInit(mobileInputContainer, mobileInputContainer);
            }
        });
    },
    computed: {
        ...mapState(['formSubmitting']),
        formattedMobileForITI() {
            if (!this.mobile) return;

            return this.mobile.replace('-', '');
        },
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        }
    },
    methods: {
        onInput(e) {
            let { value } = e.target;
            let countryData = this.iti.getSelectedCountryData();
            let { dialCode } = countryData;
            this.mobileCheck = value;
            this.mobile = `+${dialCode}-${value}`;

            this.$emit('change', this.mobile);
        },
        preFill() {
            if (this.mobile !== '') {
                this.iti.setNumber(this.formattedMobileForITI);
            }
        },
        postInit(inputContainer, listContainer) {
            addSearch(this.$gettext, listContainer, {
                target: '.country-list',
                searchWrapperClass: 'telinput-search',
                searchLabelClass: 'telinput-search__label',
                searchInputClass: 'telinput-search__input',
                searchables: countries,
                byDataCode: 'data-country-code'
            });
            initWindowHandler(inputContainer, listContainer);
            initEvents(inputContainer, listContainer);
        },
        labelPositioning() {
            let { mobileInputLabel, mobileInputContainer } = this.$refs;
            labelPositioning(mobileInputLabel, mobileInputContainer);
        },
        hidePlaceholder() {
            this.placeholderHidden = true;
        },
        showPlaceholder() {
            !this.mobileCheck.length ? (this.placeholderHidden = false) : null;
        }
    },
    components: {
        InlineError
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/PhoneInput.vue